module.exports = __webpack_public_path__ + "static/media/achtertuin_2.ebbb4a3f.jpeg";